import type { ApplicationPageState } from './types';

export const initialState: ApplicationPageState = null;
